import { render, staticRenderFns } from "./ReviewsIframe.vue?vue&type=template&id=e3162e72&"
import script from "./ReviewsIframe.vue?vue&type=script&lang=ts&"
export * from "./ReviewsIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports